<template>
    <b-modal id="editModal" ref="modal" title="Edit ChemicalActiveIngredient" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Chemical Active Ingredient Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Restricted Entry Interval (days)</label>
            <div class="position-relative">
                <VueMask v-model.number="contamination_period" class="form-control"
                         :class="{'is-invalid': errors.has('contamination_period')}"
                         placeholder="0..."
                         :options="{numeral: true, numeralThousandsGroupStyle: 'thousand'}" />
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!activeIngredient.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="activeIngredient.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteChemicalActiveIngredientMutation from '@views/ChemicalActiveIngredients/EditModal/mutationDeleteChemicalActiveIngredient.graphql';
import restoreChemicalActiveIngredientMutation from '@views/ChemicalActiveIngredients/EditModal/mutationRestoreChemicalActiveIngredient.graphql';
import updateChemicalActiveIngredientMutation from '@views/ChemicalActiveIngredients/EditModal/mutationUpdateChemicalActiveIngredient.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    activeIngredient: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.activeIngredient.name,
      contamination_period: this.activeIngredient.contamination_period,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateChemicalActiveIngredientMutation,
            variables: {
              input: {
                id: this.activeIngredient.id,
                name: this.name,
                contamination_period: this.contamination_period,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateChemicalActiveIngredient: {
                ...this.activeIngredient,
                name: this.name,
                contamination_period: this.contamination_period,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Chemical Active Ingredient updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteChemicalActiveIngredientMutation,
          variables: {
            input: {
              id: this.activeIngredient.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical Active Ingredient disabled!');
          this.$emit('refresh');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreChemicalActiveIngredientMutation,
          variables: { input: { id: this.activeIngredient.id, }, },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreChemicalActiveIngredient: {
              ...this.activeIngredient,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Chemical Active Ingredient restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
